/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Room_Blocked_MultisensorsInputs */



/**
* | output |
* | --- |
* | "The room still contains multisensors" |
*
* @param {Delete_Room_Blocked_MultisensorsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const delete_room_blocked_multisensors = /** @type {((inputs?: Delete_Room_Blocked_MultisensorsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Room_Blocked_MultisensorsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The room still contains multisensors")
	return /** @type {LocalizedString} */ ("La pièce contient encore des multicapteurs")
});